import styled from 'styled-components';

import { ConfirmModal } from '../../../../../components';

export const ConfirmModalWrapper = styled(ConfirmModal)`
  .MuiTypography-h4 {
    font-family: MultiplaneTWDC;
    font-size: 28px;
    font-style: normal;
    font-weight: 500;
    line-height: 38px;
    color: ${({ theme }): string => theme.admanColors!.gray.dark.fg[5]};
  }

  .MuiTypography-body1 {
    font-family: Graphik;
    font-style: normal;
    font-weight: 400;
    font-size: 14px;
    line-height: 160%;
    color: ${({ theme }): string => theme.admanColors!.gray.dark.fg[5]};
  }

  .TrekButton-outlined {
    border-width: 2px;
  }

  .TrekButton-label > span {
    text-transform: capitalize;
  }
`;

export const StyledIconWrapper = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;

  span {
    padding: ${({ theme }): string => theme.spacers!.spacer02};
  }

  .descriptionTooltip {
    max-width: 330px;
    line-height: 1.5em;
  }
`;
